import { render } from "./ItemMaster.vue?vue&type=template&id=19780230&scoped=true"
import script from "./ItemMaster.vue?vue&type=script&lang=js"
export * from "./ItemMaster.vue?vue&type=script&lang=js"

import "./ItemMaster.vue?vue&type=style&index=0&id=19780230&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19780230"]])

export default __exports__